import PublicRoutes from "./PublicRoutes";
export default function SourceApp() {
  return <PublicRoutes />;
}
